module.exports = __webpack_public_path__ + "img/letsbuildacomic.41cb0234.png";